import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectFixInstrument: "selectFixInstrument [Action]",
  selectFixInstrumentLoading: "selectFixInstrumentLoading [Action]",
  selectFixInstrumentAsync: "selectFixInstrumentAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_fix_instrument_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectFixInstrument:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.selectFixInstrumentLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.selectFixInstrumentLoading, payload: true });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "market_maker",
    method_type: "select_fix_instrument",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectFixInstrument,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectFixInstrumentLoading,
      payload: false,
    });
  }
}

export function* selectFixInstrument() {
  yield takeLatest(actionTypes.selectFixInstrumentAsync, handleWorker);
}
